import { createSelector } from 'reselect';

const getData = state => {
  return state;
};

export const searchTermData = createSelector(
  getData,
  data => data.SearchTermDataReducer
);
